'use strict';

$('.summary-tab-pane').on('mouseenter mouseleave', '.popup-button', function() {
    $(this).siblings('.popup-for-images').toggleClass('hide');
})
